/*
 * @Author       : dengjianjun
 * @Date         : 2021-10-21 19:15:00
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2022-01-04 16:19:42
 * @Description  :
 * @FilePath     : /es-template/src/store/modules/hotel/getter.js
 */
import { formatDate, getDayByOffset, compare } from '@didi/es-mpx-shared';
import dayjs from 'dayjs'

export default {
  /**
   * @description: 限制时间
   */
  limitDate(state) {
    let limitForChange = false
    const minDate = formatDate(Date.now(), 'YYYY-MM-dd')
    const maxDate = formatDate(getDayByOffset(minDate, 14), 'YYYY-MM-dd')
    let maxDateForReserve = formatDate(getDayByOffset(minDate, 59), 'YYYY-MM-dd')
    const startTimePrev = state.changeOrderInfo?.select_order?.start_time
    if (startTimePrev) {
      const compareTime = dayjs().isBefore((getDayByOffset(startTimePrev, -2)))
      if (!compareTime) { // 发车时间不到48小时
        // maxDate = formatDate(startTimePrev, 'YYYY-MM-dd')
        limitForChange = true
      }
    }
    return {
      minDate,
      maxDate,
      maxDateForReserve,
      limitForChange
    }
  },
}
